import './todo.css'
import Todos from './Todos';
import { useContext, useEffect } from 'react'
import { ThemeContext } from '../../context';
import {GetApiAction} from '../../redux/action/action';
import { useDispatch, useSelector } from 'react-redux';
import Model from './Model';

export default function Todo() {
    const dispatch = useDispatch();

    const responseData = useSelector(state=>state.Reducer.details)

    useEffect(()=>{
        dispatch(GetApiAction())
    },[dispatch]);


    const theme = useContext(ThemeContext)
    var l = 'table-leight'
    if(theme.currentTheme === 'l'){
        l = 'table-leight'
    }else{
        l = 'table-dark'
    }

    
  return (
    <div className='todocntr'>
      <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#AddModalData">Add Data</button>
      <Model id="AddModalData" />

        <table className={`table table-bordered ${l}`}>
          <thead className=''>
            <tr>
              <th scope="col">Sr.No.</th>
              <th scope="col">First</th>
              <th scope="col">Last</th>
              <th scope="col">Email</th>
              <th scope="col">Update</th>
              <th scope="col">Delete</th>
            </tr>
          </thead>
          <tbody>
            {responseData.map((item, index) =>{
                return(<Todos key={index} id={item.id} srno={index+1} fname={item.fname} lname={item.lname} email={item.email} />)
            })}
          </tbody>
        </table>
        
      </div>
  )
}
